export default __webpack_public_path__ + "static/media/phones.5162ea17.png";